// Découpage et comptage du Markdown des pages légales. Ce module reste pur —
// aucun import de react-markdown, qui est en modules ES et n'est pas
// transformé par Jest : c'est ce qui le rend testable directement. Le rendu
// vit dans TexteLegal.jsx.

function sansAccents(texte) {
  return texte
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

// Parcourt les lignes de titre de niveau 2 en sautant les blocs de code : un
// « ## » dans une clôture ``` n'est pas un titre.
function* titresDeNiveau2(markdown) {
  const lignes = markdown.split('\n')
  let dansUnBloc = false
  for (let i = 0; i < lignes.length; i += 1) {
    if (/^\s*(```|~~~)/.test(lignes[i])) {
      dansUnBloc = !dansUnBloc
      continue
    }
    if (dansUnBloc) continue
    const titre = /^##\s+(.*\S)\s*$/.exec(lignes[i])
    if (titre) yield { index: i, texte: titre[1] }
  }
}

export function compterSections(markdown) {
  let total = 0
  // eslint-disable-next-line no-unused-vars
  for (const _titre of titresDeNiveau2(markdown)) total += 1
  return total
}

/**
 * Isole la section « transparence sur l'usage de l'intelligence artificielle »
 * du reste du contenu, pour que la page puisse lui donner son propre panneau.
 *
 * Le contenu vient du back-office : la gérante peut renommer ce titre, et le
 * découpage doit alors échouer proprement plutôt que casser la page. La
 * reconnaissance se fait donc sur la présence de « intelligence artificielle »
 * dans le titre, pas sur une correspondance exacte, et l'absence de section
 * rend `null` — l'appelant affiche alors le contenu d'un seul tenant.
 */
export function decouperSectionIa(markdown) {
  const titres = Array.from(titresDeNiveau2(markdown))
  const rang = titres.findIndex((titre) => sansAccents(titre.texte).includes('intelligence artificielle'))
  if (rang === -1) return null

  const lignes = markdown.split('\n')
  const debut = titres[rang].index
  const fin = rang + 1 < titres.length ? titres[rang + 1].index : lignes.length

  return {
    avant: lignes.slice(0, debut).join('\n').trim(),
    ia: {
      titre: titres[rang].texte,
      corps: lignes.slice(debut + 1, fin).join('\n').trim(),
    },
    apres: lignes.slice(fin).join('\n').trim(),
  }
}
